import { render, staticRenderFns } from "./HealthReportTable.vue?vue&type=template&id=31f0ddc4&scoped=true"
import script from "./HealthReportTable.vue?vue&type=script&lang=js"
export * from "./HealthReportTable.vue?vue&type=script&lang=js"
import style0 from "./HealthReportTable.vue?vue&type=style&index=0&id=31f0ddc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0ddc4",
  null
  
)

export default component.exports